export default "__VITE_ASSET__Ws13BELu__"